import {degreeToRadian, notNull} from "../../utils/utils";
import BaseSlideMap from "./BaseSlideMap";

class TileSlideMap extends BaseSlideMap {

	unit = "microns";
	metersPerUnit = 1 / 1e6;
	key = `tile-slide-map-${this.props.id}`;

	componentDidUpdate(prevProps, prevState, snapshot) {
		let rotation = this.props.displaySetting?.rotation;
		if (prevProps.displaySetting?.rotation !== rotation && notNull(rotation))
			this.map.getView().setRotation(degreeToRadian(rotation));
	}

	getImageShape = () => {
		let {slide} = this.props;
		return [slide.uperpixel * slide.tile_width * slide.x_fields,
			slide.uperpixel * slide.tile_height * slide.y_fields];
	}
}

export default TileSlideMap;
